import React, { FC, useCallback, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Organization, OrganizationSettings, ReduxState } from 'types';
import {
  DEVELOPMENT_PLAN_INITIAL_SUBMIT_INPUTS,
  DEVELOPMENT_PLANS_BASE_URL_PATH,
  DevelopmentPlan,
  toApiSubmit,
} from 'utils/models/DevelopmentPlan';
import { useDevelopmentPlanAdmin } from 'utils/models/User';
import ModalEditorButton from 'views/Widgets/Modals/ModalEditorButton';

interface Props {
  title?: string;
  callback?: (o: DevelopmentPlan) => void;
  currentOrganization: Organization;
  settings: OrganizationSettings;
}

const ModalDevelopmentPlanEditorButton: FC<Props> = ({
  callback = () => {},
  currentOrganization,
  settings,
}) => {
  const { formatMessage } = useIntl();
  const [object, setObject] = useState(undefined);

  const handleDevelopmentPlanChange = useCallback((o) => {
    setObject((prev) => {
      // @ts-expect-error
      if (prev?.template_id !== o?.template_id) {
        return {
          ...o,
          candidate_person: undefined,
          supporter_person: undefined,
        };
      }
      return o;
    });
  }, []);
  const developmentPlanAdminConfig = useDevelopmentPlanAdmin();
  const inputs = useMemo(() => {
    return DEVELOPMENT_PLAN_INITIAL_SUBMIT_INPUTS(
      formatMessage,
      settings.development_plans_templates,
      true,
      developmentPlanAdminConfig,
      // @ts-expect-error
      object?.template_id
    );
  }, [
    formatMessage,
    settings.development_plans_templates,
    // @ts-expect-error
    object?.template_id,
    developmentPlanAdminConfig,
  ]);

  const onValidate = useCallback((_obj) => {
    return [];
  }, []);

  const output = useMemo(
    () => (
      <>
        <ModalEditorButton
          block
          url={DEVELOPMENT_PLANS_BASE_URL_PATH}
          title={formatMessage({
            id: 'app.views.development_plans.modal_development_plan_editor_button.title.create_development_plan',
            defaultMessage: 'Create development plan',
          })}
          submitText={formatMessage({
            id: 'app.views.development_plans.modal_development_plan_editor_button.submitText.create_development_plan',
            defaultMessage: 'Create development plan',
          })}
          object={object}
          onChange={handleDevelopmentPlanChange}
          onClosed={() => setObject(undefined)}
          onValidate={onValidate}
          inputs={inputs}
          transformObjectBeforeSubmit={(p) =>
            toApiSubmit(p, currentOrganization)
          }
          callback={callback}
        />
      </>
    ),
    [
      object,
      handleDevelopmentPlanChange,
      onValidate,
      inputs,
      callback,
      currentOrganization,
      formatMessage,
    ]
  );

  return output;
};

const mapStateToProps = (state: ReduxState) => {
  const { features, currentOrganization, settings } = state;

  return {
    features,
    currentOrganization,
    settings,
  };
};

export default connect(mapStateToProps)(
  React.memo(ModalDevelopmentPlanEditorButton)
);
